const GLOBAL_NAME = '__INTELLIKEY_NATIVE_ENVIRONMENT__'

const getNativeEnvironment = () => {
  if (typeof window === 'undefined') return null

  const environment = window[GLOBAL_NAME]
  if (!environment || environment.version !== 1 || typeof environment.platform !== 'string') {
    return null
  }
  return environment
}

const getNativePlatform = () => {
  const environment = getNativeEnvironment()
  return environment ? environment.platform : null
}

const hasNativeCapability = capability => {
  const environment = getNativeEnvironment()
  return Boolean(
    environment &&
    environment.capabilities &&
    environment.capabilities[capability] === true
  )
}

const isIntelliKeyMacApp = () => getNativePlatform() === 'macos'
const isIntelliKeyWindowsApp = () => getNativePlatform() === 'windows'

const hasAppleInteropBridge = () => Boolean(
  typeof window !== 'undefined' &&
  window.webkit &&
  window.webkit.messageHandlers &&
  window.webkit.messageHandlers.interOp &&
  typeof window.webkit.messageHandlers.interOp.postMessage === 'function'
)

const hasNativeMessageBridge = () => Boolean(
  typeof window !== 'undefined' && (
    window.ReactNativeWebView ||
    hasAppleInteropBridge() ||
    (window.chrome &&
      window.chrome.webview &&
      typeof window.chrome.webview.postMessage === 'function')
  )
)

const hasNativeIdentityBridge = () => Boolean(
  hasNativeMessageBridge() && (
    hasNativeCapability('nativeIdentity') ||
    hasAppleInteropBridge()
  )
)

export {
  GLOBAL_NAME,
  getNativeEnvironment,
  getNativePlatform,
  hasAppleInteropBridge,
  hasNativeCapability,
  hasNativeIdentityBridge,
  hasNativeMessageBridge,
  isIntelliKeyMacApp,
  isIntelliKeyWindowsApp
}
